import axios from 'axios';

const getCotacoes = params => axios.get('/cotacoes', {
  params,
});

const getCotacoesList = params => axios.get('/cotacoes/list', {
  params,
});

const getCotacao = id => axios.get(`/cotacoes/${id}`);

const cancelar = (id, data) => axios.put(`/cotacoes/${id}/cancelar`, data);

const save = (cotacao) => {
  if (cotacao.id) {
    return axios.put(`/cotacoes/${cotacao.id}`, cotacao);
  }
  return axios.post('/cotacoes', cotacao);
};

const updateCotacao = cotacao => axios.put(`/cotacoes/${cotacao.id}/edit`, cotacao);

const saveRascunho = (cotacao) => {
  if (cotacao.id) {
    return axios.put(`cotacoes/rascunhos/${cotacao.id}`, cotacao);
  }
  return axios.post('cotacoes/rascunhos', cotacao);
};

const excluirRascunho = id => axios.delete(`cotacoes/rascunhos/${id}`);

const updateIdentifier = (id, cotacao) => axios.put(`/cotacoes/${id}/identifier`, cotacao);

const getSolicitacoes = id => axios.get(`/cotacoes/${id}/solicitacoes-respostas`);

const addFornecedor = (idCotacao, idFornecedor) => axios.put(`/cotacoes/${idCotacao}/fornecedores/${idFornecedor}`, {});

const addFornecedores = (idCotacao, data) => axios.post(`/cotacoes/${idCotacao}/fornecedores`, data);

const getFromRequisicao = idRequisicao => axios.get(`/requisicoes/${idRequisicao}/cotacao`);

const getFromRequisicoesProdutos = data => axios.post('/requisicoes/cotacao', data);

const getLinks = idCotacao => axios.get(`/cotacoes/${idCotacao}/links`, {});

export default {
  getCotacoes,
  getCotacoesList,
  getCotacao,
  save,
  updateCotacao,
  cancelar,
  updateIdentifier,
  getSolicitacoes,
  addFornecedor,
  addFornecedores,
  getFromRequisicao,
  getFromRequisicoesProdutos,
  saveRascunho,
  excluirRascunho,
  getLinks,
};
